import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./design.scss";
const Design = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    function handleScroll() {
      setOffset(window.pageYOffset);
    }

    window.addEventListener("scroll", handleScroll);
  });

  return (
    <div className="home-design">
      <div className="bg"></div>
      <h1>
        <FormattedMessage
          id="Studio"
          defaultMessage="Ylliri is a design studio based in Kosovo. Our team delivers compelling brand experiences for emerging and established companies. Our approach is as strategic as it is visually driven."
        />
      </h1>

      <div
        className="design-img"
        style={{
          transform: `rotate(${offset * 0.05}deg)  `,
        }}
      ></div>

      <Link to="/">
        <FormattedMessage id="LearnMore" defaultMessage="Learn More" />
      </Link>
    </div>
  );
};

export default Design;
